<template>
  <div>
    <h1 class="page-header">{{ $t('subprogram.subprogram') }}</h1>
    <div class="row">
      <div class="col-lg-3 col-md-5 col-sm-12">
        <ts-card>
          <ts-card-wrapper>
            <form-create @success_create="fetchData" :edit="edit_data" @success_update="edit_data = ''"
              @cancel="fetchData"></form-create>
          </ts-card-wrapper>
        </ts-card>
      </div>
      <div class="col-lg-9 col-md-7 col-sm-12">
        <ts-card>
          <ts-card-wrapper>
            <div class="row">
              <div class="col-lg-9 com-md-9 col-sm-12 d-flex justify-content-start">
                <p class="ts-text-gray-500">
                  <b><i><span class="text-danger">* </span>{{ $t('subprogram.note') }}:
                    </i></b>
                  {{ $t('subprogram.onlyuseratheadofficecanmodifyordelete') }}
                </p>
              </div>
              <div class="col-lg-3 com-md-3 col-sm-12 d-flex justify-content-end">
                <ts-input v-model="search" :placeholder="$t('Search')" style="width: 300px;" class="kh-font" />
              </div>
            </div>
          </ts-card-wrapper>
          <ts-table :columns="columns" :records="resources" :loading="loading" :expandable="true"
          :rowGroup="{
          field: 'main_program.acp_name_foreign'
           }">
            <template v-slot="{ record }">
              <td class="kh-font">{{ record.acps_name_native }}</td>
              <td>{{ record.acps_name_foreign }}</td>
              <td>{{ record.acps_abbr }}</td>
              <td>
                {{
                  record.main_program !== null
                  ? record.main_program.acp_name_foreign
                  : ''
                }}
              </td>
              <td class="text-center">
                <a href="#" title="edit" class="text-primary mr-2" @click.prevent="edit(record)">
                  <i class="fas fa-edit"></i>
                </a>
                <a href="#" title="delete" class="text-danger" @click.prevent="destroy(record.acps_id)">
                  <i class="fas fa-trash"></i>
                </a>
              </td>
            </template>
            <div slot="expand" slot-scope="prop">
              <table class="ts-w-full">
                <thead>
                  <tr>
                    <th class="ts-w-5">{{ $t('mainProgram.no') }}</th>
                    <th>{{ $t('mainProgram.scoringCycle') }}</th>
                    <th class="ts-w-5">{{ $t('mainProgram.displayInScoring') }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(scoring, index) in prop.record.scoring_cyles" :key="index">
                    <td>{{ index + 1 }}</td>
                    <td>
                      {{ scoring.scoring_cycle.scoring_cycle_name }}
                    </td>
                    <td>
                      <p>
                        {{ scoring.display_in_scoring == false ? 'No' : 'Yes' }}
                      </p>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </ts-table>
          <ts-card-wrapper class="d-flex justify-content-end p-15">
            <ts-pagination v-model="pagination" @navigate="fetchData">
            </ts-pagination>
          </ts-card-wrapper>
        </ts-card>
      </div>
    </div>
  </div>
</template>

<script>
import { debounce } from 'lodash'
import { mapState } from 'vuex'
import FormCreate from './form.vue'

export default {
  components: {
    FormCreate
  },
  name: 'sub-program',
  props: ['editData'],
  data() {
    return {
      edit_data: this.editData,
      loading: false,
      columns: [
        { name: 'name kh' },
        { name: 'name en' },
        { name: 'abbreviation' },
        { name: 'main program' },
        { name: 'Actions', style: 'width: 1px; text-align:center' }
      ]
    }
  },
  created() {
    this.fetchData()
  },
  computed: {
    ...mapState('subProgram', ['resources', 'pagination']),
    search: {
      get() {
        return this.$store.state.subProgram.search
      },
      set(newVal) {
        this.$store.commit('subProgram/SET_SEARCH', newVal)
        this.$store.commit('subProgram/RESET_CURRENT_PAGE')
      }
    }
  },
  methods: {
    fetchData(attributes) {
      this.loading = true

      this.$store
        .dispatch('subProgram/fetch', attributes)
        .then(() => (this.loading = false))
        .catch(error => {
          this.$toasted.error(error.message)
          this.loading = false
        })
    },

    edit(data) {
      this.edit_data = data
      this.$router.push(`/sub-programs/${data.acps_id}`)
    },

    async destroy(id) {
      if (await this.$confirmModal.danger('Are you sure to delete ?')) {
        this.$store
          .dispatch('subProgram/delete', id)
          .then(response => {
            this.$toasted.success(response.message)
            this.fetchData()
          })
          .catch(error => {
            this.$toasted.error(error.message)
          })
      }
    }
  },
  watch: {
    search: debounce(function (search) {
      this.fetchData({ search })
    }, 500)
  },
  beforeRouteLeave(to, from, next) {
    if (_.isEmpty(to.params) && to.name != 'sub-program-create') {
      this.$store.commit('subProgram/RESET_STATE')
    }
    next()
  }
}
</script>
